import { render, staticRenderFns } from "./AdvertiserCampaigns.vue?vue&type=template&id=7621cd36&"
import script from "./AdvertiserCampaigns.vue?vue&type=script&lang=ts&"
export * from "./AdvertiserCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports